import type { Contact } from "../types";
// GAVION demo-contact: a nameless demo attendee shows his email
import { contactLabel } from "@/components/gavion/domain/dialer/contactCall";
import { ContactCreate } from "./ContactCreate";
import { ContactEdit } from "./ContactEdit";
import { ContactList } from "./ContactList";
import { ContactShow } from "./ContactShow";

export default {
  list: ContactList,
  show: ContactShow,
  edit: ContactEdit,
  create: ContactCreate,
  recordRepresentation: (record: Contact) => contactLabel(record ?? {}),
};
